import { defineComponent as _defineComponent } from 'vue'
import Detail from './detail.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'redact',
  setup(__props) {


return { __sfc: true,Detail }
}

})